export enum CallType {
  Audio = 'Audio',
  Video = 'Video',
}
